// extracted by mini-css-extract-plugin
module.exports = {"playVideo":"PlayVideoButton-module--playVideo--V7bk9","icon":"PlayVideoButton-module--icon--flgD3"};